module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/68AmGOBpOckAWio5jQLmZn-7d37430be3e02ae70b5890308acccca9.jpg";